import JSEncrypt from "jsencrypt";

const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCTFuFeMKgV2T9ymAJjQzybnj1k
E/eIAFXE10enNDmg+twyuSta471Cf9Wr+RJQYuepKTDNs5iauXMXKr9YCTvaSuGM
eF5WAwJ7juFzk8pAoP5txDdxfjgJRf1u6Str7xNMRcCYUxs6R/k+a+6Mhlm4sUik
6jfMbbltKPKrl+vqWQIDAQAB
-----END PUBLIC KEY-----`
const privateKey = `-----BEGIN RSA PRIVATE KEY-----
MIICXAIBAAKBgQC5uuCWAh7l5qWUFwC2wmJHcJSMC9RIUOiRr7OBcl5es2Ybz1SE
Ij5RX/7Q0qMYkhTiPWgNO6eakdqE4d8FbVWIQH4NCChYAhVVHowUx38qiTn08NNr
kWWxJnY2segYNRfzhWWq0dXf0PDnbDrXc6BggexW4xMyeNa6PtcaDSLjEQIDAQAB
AoGAdlrrMUyqqfCgBU3fS5d1j3bjgpcrMOY2PliL+GqMTqbd48zsW8OCmNKmjCYe
ftLgcgeVnhEszigx60oQl+HDhZaw2Tneyk9Jn5QULMlg0Rout0sywpizOqlPXqPc
XU8EEeN8iPpT5EPRkko95bMHZGmki1LyE6w2k/+loRgWYNECQQD5yq/D2r0772XG
kdEXmvZxs4/QjwHjXRTVNxbFCEZL3H+0yolvWIF7vnPBJqcZtmthw76g9jAnpDIQ
OdqQgPMVAkEAvliYJtMflqkrU2sjzv8g/cl1Y5WtXNCCGlj/v5fd9C8VPyFbyNDU
HoUfyGDXvSe+VLQnGtGT5hhywDZS2ksfDQJBAKmeHpgp8pG+UCf0YD1dNreirKd8
VFXloP3feJC2u7VLt1Q2q/h16wbyHnwsGQ/2tRgf6VQ3mB9y+aPXBTlWtrkCQAgR
hVGP/XTLcvS0Q+5QTjuzwHAaNiELDZjEUQL0Ewp4vHPSnCtk/rjUd8ZspHh2KNE6
WbX/UD+epa6UHur16DkCQGZgnqCVL1715zBx0NyH78ZB8bMNoXyaqEs0BoMx6AvN
FTUS1Fn2/NHbQbFMd6cipWe/6cDumEDKpoMKLUFlE28=
-----END RSA PRIVATE KEY-----`

// 加密
export const encrypt = (txt) => {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export const decrypt = (txt) => {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}



// WEBPACK FOOTER //
// ./src/utils/crypto.js